import { Divider, Form, Modal } from 'antd'
import Avatar from 'components/Avatar'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import AntdInput from 'components/Form/Input'
import CopyIcon from 'components/icons/CopyIcon'
import EmailAtIcon from 'components/icons/EmailAtIcon'
import Emptystates from 'components/icons/Emptystates.svg'
import FacebookIcon from 'components/icons/FacebookIcon'
import LinkedIcon from 'components/icons/LinkedIcon'
import TwitterIcon from 'components/icons/TwitterIcon'
import WhatsappIcon from 'components/icons/WhatsappIcon'
import Label from 'components/Label/Label'
import DetailsHeader from 'modules/Roles/ViewRole/Header/JobDetailsDrawer/DetailsHeader'
import {
  CenteredDiv,
  ColListIcon,
  Content,
  DisplayPad,
  LinkText,
  MailSubHeading,
  RowListIcon,
  RowListLabel,
  RowPadding,
  ShareLink,
  ShareSection,
  ShareWrap,
} from 'modules/Roles/ViewRole/Style/style'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share'
import { IsValidEmail } from 'utils/emailValidation'
import { formatNumber } from 'utils/formatNumber'
import SuccessMessage from 'utils/SuccessMessage'
const { REACT_APP_JOB_SHARING_URL } = process.env

const ShareDrawer = ({
  shareDrawer,
  setShareDrawer,
  singleRoleData,
  corporateId,
  jobSharingEmail,
}) => {
  const params = useParams()
  const checkJobTypeLevel = (data, YOE) => {
    const transformedData = data?.map(item => {
      switch (item) {
        case 'ENTRY':
          return 'Entry Level'
        case 'INTERN':
          return 'Internship'
        case 'EXPERIENCED':
          return ` ${YOE[0]} - ${YOE[1]} Yrs Experience `
        default:
          return item
      }
    })

    return transformedData?.toString()
  }

  const shareUrl = `${REACT_APP_JOB_SHARING_URL}${corporateId}/${params?.jobId}`
  const [form] = Form.useForm()
  const [isCopied, setIsCopied] = useState(false)
  const [emailModel, setEmailModel] = useState(false)
  const [load, setLoad] = useState(false)
  const onShareClick = copyText => {
    navigator.clipboard.writeText(copyText)
    SuccessMessage('Copied')
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false)
    }, 10000)
  }

  const handleEmailOnClick = () => {
    setEmailModel(true)
  }
  const handleEmailCancel = () => {
    setEmailModel(false)
  }
  const onEmailEntered = e => {}
  const sendEmailOTP = async values => {
    let mandatory = singleRoleData?.mandatorySkillName
      ?.map(item => item?.name)
      ?.join(',')
    let optional = singleRoleData?.optionalSkillsName
      ?.map(item => item?.name)
      ?.join(',')
    let remote = singleRoleData?.remoteCities?.map(item => item.name)?.join(',')
    let city = singleRoleData?.cities.map(item => item.name)?.join(',')
    let yearOfPassing = singleRoleData?.yearOfPassing?.join(',')
    let experiences = checkJobTypeLevel(
      singleRoleData?.jobTypeLevels,
      singleRoleData?.yearOfExperience
    )
    let degree = singleRoleData?.degreeStreamMap?.map(
      item => item?.degree?.name + '-' + item?.stream?.name
    )

    let ctc =
      singleRoleData?.minCompensation == singleRoleData?.maxCompensation
        ? formatNumber(Number(singleRoleData?.minCompensation))
        : '₹' +
          formatNumber(Number(singleRoleData?.minCompensation)) +
          ' - ' +
          '₹' +
          formatNumber(Number(singleRoleData?.maxCompensation))

    let ctcperiod =
      singleRoleData?.CTCPeriod == 'ANNUALLY'
        ? ' Per annum'
        : singleRoleData?.CTCPeriod == 'MONTHLY'
        ? ' Per month'
        : singleRoleData?.CTCPeriod == 'WEEKLY'
        ? ' Per week'
        : singleRoleData?.CTCPeriod == 'DAILY'
        ? ' Per day'
        : singleRoleData?.CTCPeriod == 'HOURLY'
        ? ' Per hour'
        : ''
    let combinedCtc = ctc + ctcperiod

    const response = await jobSharingEmail({
      setLoading: setLoad,
      payload: {
        id: singleRoleData?.id,
        email: values.Email,
        link: shareUrl,
        jobDependency: singleRoleData?.jobDependency,
        corporateName: singleRoleData?.corporate?.name,
        industry: singleRoleData?.corporate?.industry,
        cities: city,
        mandatorySkills: mandatory,
        optionalSkills: optional,
        isRemoteAllowed: singleRoleData?.isRemoteAllowed,
        remoteCities: remote,
        eligibility: degree,
        yearOfPassing: yearOfPassing,
        experience: experiences,
        tittle: singleRoleData?.tittle,
        jobType: singleRoleData?.jobType?.split('_')?.join(' ').toLowerCase(),
        description: singleRoleData?.description,
        ctcPeriod: combinedCtc,
        journey: 'Corporate',
      },
    })

    if (response?.status >= 200 && response?.status <= 300) {
      setEmailModel(false)
      form.resetFields()
    }
  }

  const content = () => {
    return (
      <ShareWrap column>
        <DetailsHeader
          tittle={singleRoleData?.tittle}
          status={singleRoleData?.status}
          jobyType={singleRoleData?.jobType}
          candidatesCount={`${singleRoleData?.minVacancies} - ${singleRoleData?.maxVacancies}`}
          date={singleRoleData?.endDate}
        />
        <Divider />

        <RowListIcon row>
          <ColListIcon column alignCenter>
            <LinkedinShareButton url={shareUrl}>
              <Avatar
                size={72}
                src={<LinkedIcon />}
                background={'#9D9D9D0A'}
                padding={'25px'}
              />
            </LinkedinShareButton>

            <RowListLabel>Linked In</RowListLabel>
          </ColListIcon>
          <ColListIcon column alignCenter>
            <FacebookShareButton url={shareUrl}>
              <Avatar
                size={72}
                src={<FacebookIcon />}
                background={'#9D9D9D0A'}
                padding={'25px'}
              />
            </FacebookShareButton>
            <RowListLabel>Facebook</RowListLabel>
          </ColListIcon>
          <ColListIcon column alignCenter>
            <TwitterShareButton url={shareUrl}>
              <Avatar
                size={72}
                src={<TwitterIcon />}
                background={'#9D9D9D0A'}
                padding={'25px'}
              />
            </TwitterShareButton>

            <RowListLabel>Twitter</RowListLabel>
          </ColListIcon>
          <ColListIcon column alignCenter>
            <EmailShareButton onClick={handleEmailOnClick} url={shareUrl}>
              <Avatar
                size={72}
                src={<EmailAtIcon />}
                background={'#9D9D9D0A'}
                padding={'25px'}
              />
            </EmailShareButton>

            <RowListLabel>E-Mail</RowListLabel>
          </ColListIcon>
          <ColListIcon column alignCenter>
            <WhatsappShareButton url={shareUrl}>
              <Avatar
                size={72}
                src={<WhatsappIcon />}
                background={'#9D9D9D0A'}
                padding={'25px'}
              />
            </WhatsappShareButton>
            <RowListLabel>Whatsapp</RowListLabel>
          </ColListIcon>
        </RowListIcon>
        <CenteredDiv>Or share with link</CenteredDiv>

        <LinkText>{isCopied ? 'Link Copied' : 'Click to copy link'}</LinkText>
        <ShareSection spaceBetween onClick={() => onShareClick(shareUrl)}>
          <ShareLink id="copy">{shareUrl}</ShareLink>
          <CopyIcon color={isCopied ? '#3249D7' : '#D1D2D3'} />
        </ShareSection>
      </ShareWrap>
    )
  }
  return (
    <>
      <Drawer
        width="40%"
        title={'Share Job Details'}
        placement="right"
        visible={shareDrawer}
        closable
        onClose={() => setShareDrawer(false)}
        headerpadding="16px 0"
        headermargin="0 30px"
        padding="30px"
        content={content()}
        load={load}
      />
      <Modal
        width={'585px'}
        open={emailModel}
        footer={null}
        onCancel={handleEmailCancel}
      >
        <RowPadding>
          <Content alignCenter column center>
            <Flex style={{ display: 'flex', justifyContent: 'center' }}>
              <img src={Emptystates} alt="emptyState" />
            </Flex>

            <MailSubHeading>Share Job with your friends</MailSubHeading>
          </Content>
          <Form
            style={{ width: '100%' }}
            scrollToFirstError
            onFinish={sendEmailOTP}
            id={'emailForm'}
            form={form}
            layout="vertical"
          >
            <Label>Your friend's email address *</Label>
            <AntdInput
              AntdInput
              placeholder="eg:harry@yahoo.com"
              width="100%"
              name="Email"
              onChange={onEmailEntered}
              rules={[
                () => ({
                  validator(_, value) {
                    let isValid = IsValidEmail(value)
                    if (!isValid) {
                      return Promise.reject(
                        new Error(`Please Enter Valid Email`)
                      )
                    }

                    return Promise.resolve()
                  },
                }),
              ]}
            />

            <DisplayPad>
              <Button.Primary
                htmlType="submit"
                text={'Submit'}
                width={'100%'}
                padding={'10px'}
              />
            </DisplayPad>
          </Form>
        </RowPadding>
      </Modal>
    </>
  )
}

export default ShareDrawer
